import { render } from "./NavHubs.vue?vue&type=template&id=2b9173a1"
import script from "./NavHubs.vue?vue&type=script&lang=js"
export * from "./NavHubs.vue?vue&type=script&lang=js"

import "./NavHubs.vue?vue&type=style&index=0&id=2b9173a1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__